import React from 'react';
import { injectIntl } from 'react-intl-next';
import Button, { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Flex, Grid, xcss } from '@atlaskit/primitives';
import { messages } from '../messages';
var gridStyles = xcss({
  width: '100%'
});
var closeContainerStyles = xcss({
  gridArea: 'close'
});
var titleContainerStyles = xcss({
  gridArea: 'title'
});
export var AbuseModal = injectIntl(function (_ref) {
  var isOpen = _ref.isOpen,
    onConfirm = _ref.onConfirm,
    onClose = _ref.onClose,
    formatMessage = _ref.intl.formatMessage;
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    testId: "mediaAbuseModal"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Grid, {
    gap: "space.200",
    templateAreas: ['title close'],
    xcss: gridStyles
  }, /*#__PURE__*/React.createElement(Flex, {
    xcss: closeContainerStyles,
    justifyContent: "end"
  }, /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: CrossIcon,
    label: "Close Modal",
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Flex, {
    xcss: titleContainerStyles,
    justifyContent: "start"
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: "warning"
  }, formatMessage(messages.abuse_modal_title))))), /*#__PURE__*/React.createElement(ModalBody, null, formatMessage(messages.abuse_modal_body)), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: onClose
  }, formatMessage(messages.cancel)), /*#__PURE__*/React.createElement(Button, {
    appearance: "warning",
    onClick: onConfirm
  }, formatMessage(messages.abuse_modal_submit)))));
});